export const styleConstants = {
    actionBarHeight: '50px',
    actionBarIconSize: '36px',
};